import { Locale } from '@/i18n/routing'
import createIntlMiddleware from 'next-intl/middleware'
// import { localePrefix, locales } from '../navigation'
import { NextRequest } from 'next/server'

export const locales: Locale[] = ['en', 'fr', 'de', 'ru', 'ja', 'ko', 'es', 'zh']

export const localeNames = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  ru: 'Русский',
  ja: '日本語',
  ko: '한국어',
  es: 'Español',
  zh: '简体中文',
}

export function i18nRoutingHandler(request: NextRequest) {
  const handleI18nRouting = createIntlMiddleware({
    locales,
    localePrefix: 'as-needed',
    defaultLocale: 'en',
  })
  return handleI18nRouting(request)
}
